import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=7a963f5e&scoped=true&"
import script from "./AI.vue?vue&type=script&lang=js&"
export * from "./AI.vue?vue&type=script&lang=js&"
import style0 from "./AI.vue?vue&type=style&index=0&id=7a963f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a963f5e",
  null
  
)

export default component.exports